module.exports = __webpack_public_path__ + "img/stylists-white.9eda705e.png";